export default "__VITE_ASSET__CAn3AdG$__"